import React, {Component} from 'react';
import lang from '../constants/Languages.js';
import stripHtml from './StripHtml.js';

export default function withTitle(WrappedComponent, selectData) {
    return class extends Component {
        static defaultProps = {
            basePage: 'pbl'
        };

        constructor(props) {
            super(props);
            this.state = {
            };
        };

        componentDidMount() {
            this.updateTitle();
        };

        componentDidUpdate(prevProps) {
            if (prevProps !== this.props) {
                this.updateTitle();
            }
        };

        componentWillUnmount() {
            // document.title = lang[this.props.clang].titles[this.props.basePage];
        };

        getTitle = (arr) => {
            const base = lang[this.props.clang].titles[this.props.basePage];
            const main = lang[this.props.clang].titles['main'];
            const first = lang[this.props.clang].titles[arr[0]];
            const last = lang[this.props.clang].titles[arr[0] + '-' + arr[arr.length - 1]];

            if ((arr[0] === 'results' || (arr[0] === 'advanced-results') ) && this.props.searchParams) {
                return this.props.searchParams.key ?
                          base + ' | ' + first + ' ' + lang[this.props.clang].titles['results_for'] + ': ' + this.props.searchParams.key
                        : base + ' | ' + first;
            }

            if (arr[0] === 'files' && arr[arr.length - 1] ==='search' && this.props.searchParams) {
                const area = lang[this.props.clang].titles[arr[0] + '-' + this.props.searchParams.area];
                if (area) {
                    return base + ' | ' + first + ' - ' + area;
                }
            }

            if (arr[0] === 'news' && this.props.pageData && this.props.pageData.title) {
                return base + ' | ' + first + ' - ' + (this.props.pageData.title.rendered || '');
            }

            if (arr[0] === 'collections' && this.props.match.params.id && this.props.dataAbout) {
                return base + ' | ' + first + ' - ' + (this.props.dataAbout.title.rendered || '');
            }

            if (arr[0] === 'about' && arr[1] === 'examples' && this.props.pageData && this.props.pageData.data) {
                const item = this.props.pageData.data.filter(dataItem => dataItem.id === parseInt(this.props.match.params.id, 10))[0];

                if (item) {
                    return base + ' | ' + first + ' - ' + (item.title.rendered || '');
                }
            }

            if (arr[0] === 'item' && this.props.data) {
                const type = lang[this.props.clang].titles[`item-${arr[1]}`];
                const propsData = this.props.data;

                const baseTitleName = propsData.allNames ? propsData.allNames.filter(title => title.type === 'base')[0] : false;
                const baseTitle = propsData.titles ? propsData.titles.filter(title => title.type === 'base')[0] : false;
                const incipitTitle = !baseTitle && propsData.titles ? propsData.titles.filter(title => title.type === 'incipit')[0] : false;
                const mainName = propsData.names ? propsData.names.filter(name => name.type === 'main-name')[0] : false;

                const cardName = baseTitleName ? baseTitleName.label : false
                                || baseTitle ? baseTitle.label : false
                                || incipitTitle ? incipitTitle.label : false
                                || mainName ? mainName.label : false
                                || propsData.name ? propsData.name.label : false
                                || propsData.title;

                if (type) {
                    return base + ' | ' + type + ' - ' + stripHtml((cardName || ''));
               }
            }

            if (arr[0] === 'headings' && arr[1] === 'about' && arr[2] === 'details' && this.props.detailsData) {
                return base + ' | ' + first + ' - ' + (this.props.detailsData.label || '');
            }

            if (first && last) {
                return base + ' | ' + first + ' - ' + last;
            }

            if (first) {
                return base + ' | ' + first;
            }

            if (arr.length < 1) {
                return base + ' | ' + main;
            }

            return base;
        };

        updateTitle = () => {
            if (this.props.location.pathname === "/headings/about/details" && !this.props.detailsData) {
               return;
            }

            const titleArr = this.props.location.pathname.split('/').filter((path) => path !== "");

            if (this.props.clang) {
                document.title = this.getTitle(titleArr);
            }
        };

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
};



// WEBPACK FOOTER //
// ./src/scripts/WithTitle.js